<template>
    <v-hover v-slot:default="{ hover }" open-delay="50">
        <v-card :elevation="hover ? 16 : 2">
            <v-img
                v-if="offer.add_img_path"
                v-bind:src="offer.add_img_path"
                max-height="30px"
                max-width="180px"
                alt="Placeholder image"
                style="position: absolute; right: 0px;"
            >
            </v-img>
            <v-container fluid class="pa-lg-5">
                <v-row align="center" justify="center" class="mt-5 mt-sm-0">
                    <v-col align="center" justify="center" cols="12" xl="2" lg="2" md="12" sm="12">
                        <v-img
                            v-bind:src="offer.img_path"
                            width="150px"
                            @click="openOffer(offer.affiliate_url, offer)"
                            alt="Placeholder image"
                            style="cursor: pointer;"
                        >
                        </v-img>
                        {{ $t("rating") }}
                        <v-rating
                            v-model="offer.rate"
                            half-increments
                            background-color="orange lighten-3"
                            color="orange"
                            medium
                            dense
                            readonly
                        ></v-rating>
                    </v-col>
                    <v-col align="center" justify="center" cols="12" xl="8" lg="8" md="12" sm="12">
                        <v-row>
                            <v-col cols="12" xl="3" lg="3" md="6" class="pa-0">
                                <p class="text-center mb-0 mb-lg-5">{{ $t("success_rate") }}</p>
                                <p class="text-center font-weight-bold headline">
                                    {{ offer.success_rate }}%
                                </p>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md="6" class="pa-0">
                                <p class="text-center mb-0 mb-lg-5">{{ $t("loan_sum") }}</p>
                                <p class="text-center font-weight-bold headline">
                                    {{ $t("up_to_x_currency", { sum: offer.sum }) }}
                                </p>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md="6" class="pa-0">
                                <p class="text-center mb-0 mb-lg-5">{{ $t("loan_period") }}</p>
                                <p class="text-center font-weight-bold headline">
                                    {{ $t("up_to_x_days", { days: offer.days }) }}
                                </p>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md="6" class="pa-0">
                                <p class="text-center mb-0 mb-lg-5">{{ $t("percentage_rate") }}</p>
                                <p class="text-center font-weight-bold headline">
                                    {{ $t("from_x_percent_in_day", { bet: offer.bet }) }}
                                </p>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col align="center" justify="center" cols="12" xl="2" lg="2" md="12" sm="12">
                        <v-btn
                            color="primary"
                            depressed
                            @click="openOffer(offer.affiliate_url, offer)"
                        >
                            <div class="text-left offer-button">{{ $t("get_money") }}</div>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-hover>
</template>

<script>
export default {
    name: "Offer",
    props: ["offer", "is_clickable"],
    data() {
        return {
            price: 12,
            days: 12,
        };
    },
    computed: {
        settings() {
            return this.$store.getters.APP_SETTINGS;
        },
        user() {
            return this.$store.getters.AUTH_USER;
        },
    },
    methods: {
        openOffer(url, offer) {
            if (
                this.settings.payments.enabled &&
                this.settings.payments.offer &&
                !this.user.cc_attached
            ) {
                this.$store.dispatch("OPEN_PAYMENTS_MODAL", true);
                return;
            }
            if (this.is_clickable) {
                let chosen_offer = {
                    offer: offer.id,
                    sum: this.price,
                    days: this.days,
                    aff_sub3: offer.lead_uuid,
                    pattern_id: offer.pattern_id,
                };
                this.$store.dispatch("CHOSE_OFFER", chosen_offer);

                if (
                    sessionStorage.getItem("source") != "" &&
                    sessionStorage.getItem("source") != null
                ) {
                    var re = new RegExp("\A?aff_sub4=[^&]+", "i");
                    if (url.match(re)) {
                        url = url.replace(re, "aff_sub4=" + sessionStorage.getItem("source"));
                    } else {
                        re = new RegExp("\A?s4=[^&]+", "i");
                        if (url.match(re)) {
                            url = url.replace(re, "s4=" + sessionStorage.getItem("source"));
                        }
                    }
                }
                window.open(url, "_blank");
            }
        },
    },
};
</script>

<style>
.offer-button {
    font-size: 13px;
}
</style>
